module.exports = __webpack_public_path__ + "images/billing-ribbon.png";